import { render, staticRenderFns } from "./context-header.vue?vue&type=template&id=56d29dce&"
import script from "./context-header.vue?vue&type=script&lang=ts&"
export * from "./context-header.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports